import * as yup from "yup";

export const contactUsSchema = yup.object().shape({
  address: yup.string().required("The field is required"),
  description: yup.string().required("Message is required").max(255, "Maximum 255 characters"),
});
